const { populate } = require('@/functions/objects');

/**
 * This object represents an item that does exist for a company but the underlying Item (Ticket/Product/etc.) may not
 * exist in IndexedDB currently (or ever) for the current branch/user.
 */
class PlaceholderItem {
    constructor(data = {}) {
        this.ID = null;
        this.itemType = '';
        this.name = '';
        this.branchIDs = [];

        /**
         * @type {AbstractItem|Ticket|Product}
         */
        this.item = null;

        /**
         * To allow sorting. This becomes the item's navOrder when set.
         *
         * @type {number}
         */
        this.navOrder = Infinity;

        populate(this, data);
    }

    /**
     * @param {AbstractItem} item
     */
    setItem(item) {
        this.item = item;
        this.navOrder = item.navOrder;
    }
}

module.exports = PlaceholderItem;
